import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
  CardElement
} from "@stripe/react-stripe-js";
import ApiService from "../../../services/api.service";
import Helper from '../../../common/helper';
import TagManager from 'react-gtm-module';

import poweredByStripe from '../../../assets/images/powered-by-stripe.png';

export default function CheckoutForm({goNextStep, localStorageDatas, locationData, clientSecret, transactionId, subscriptionTransaction}) {

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  //const [clientSecret, setClientSecret] = useState('');
  const stripe = useStripe();
  const elements = useElements();

  //const [clientSecret, setClientSecret] = useState();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const getClientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!getClientSecret) {
      return;
    }

    

    //setClientSecret(getClientSecret);

    /*stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          goNextStep()
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });*/
  }, []);

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d"
        }
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    }
  };

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  const handleSubmit = async ev => {
    ev.preventDefault();
    setProcessing(true);

    const payload = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement)
      }
    });
    if (payload.error) {
      setError(`Payment failed ${payload.error.message}`);
      setProcessing(false);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true); 
      goNextStep(transactionId, subscriptionTransaction, "Stripe");
    }
  };

  /*return (
    <form>
      <PaymentElement class=".StripeElement--complete" />
      <button>Submit</button>
    </form>
  );*/

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
      <button
        disabled={processing || disabled || succeeded}
        id="submit"
      >
        <span id="button-text">
          {processing ? (
            <div className="spinner" id="spinner"></div>
          ) : (
            "Pay now"
          )}
        </span>
      </button>
      <div className="holder-img-stripe">
        <img src={poweredByStripe} className="img-stripe" alt="powered by stripe"/>
      </div>
      {/* Show any error that happens when processing the payment */}
      {error && (
        <div className="card-error" role="alert">
          {error}
        </div>
      )}
      {/* Show a success message upon completion */}
      <p className={succeeded ? "result-message" : "result-message hidden"}>
        Payment succeeded, see the result in your
        <a
          href={`https://dashboard.stripe.com/test/payments`}
        >
          {" "}
          Stripe dashboard.
        </a> Refresh the page to pay again.
      </p>
    </form>
  );
}